module.exports = __webpack_public_path__ + "static/media/xmltotable.f8335f6e.svg";